import { render } from "./StaticPage.vue?vue&type=template&id=64c42c50"
import script from "./StaticPage.vue?vue&type=script&lang=js"
export * from "./StaticPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__